__webpack_require__.p = "/mailbox-sidebar-changes-executor-change/onboarding/";